import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
export function getClient() {
  return noAuthApiClient;
}